<template>
  <v-container fluid v-if="item">
    <v-card class="mx-auto">
      <v-img v-if="showImages" :src="featuredImg" height="300px" lazy-src></v-img>

      <v-card-title>
        <h4 class="display-2 mb-0">
          <v-icon x-large>{{supplierTypeIcon(item.serviceType)}}</v-icon>
          {{item.name}}
        </h4>
      </v-card-title>
      <v-card-text>
        <div v-for="(supplierContent) in filter(item.allContents)" :key="supplierContent.id">
          <h2 class="title pa-2">
            {{supplierContent.name}}
            <v-btn fab small @click="onEditContent(supplierContent)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </h2>
          <div v-html="supplierContent.description"></div>
        </div>
        <v-divider class="mt-2"></v-divider>
        <div v-for="(supplierService) in item.allServices" :key="supplierService.id">
          <v-subheader class="title">{{supplierService.name}}</v-subheader>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex
                v-for="(serviceContent) in filter(supplierService.allContents)"
                :key="serviceContent.id"
              >
                <content-item
                  :item="serviceContent"
                  :show-image="showImages"
                  @editContent="onEditContent($event)"
                ></content-item>
                <hr />
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-card-text>
    </v-card>
    <content-editor
      :show="showContentEditor"
      :content="editedContent"
      @editCancel="onEditCancel"
      @contentSaved="onContentSaved($event)"
    ></content-editor>
  </v-container>
</template>

<script>
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
import ContentItem from "../../shared/ContentItem";
import ContentEditor from "../../shared/contents/ContentEditor";
export default {
  name: "SupplierContentsItem",
  mixins: [SupplierTypeIconMixin],
  props: {
    item: {
      type: Object,
      default: false
    },
    showImages: {
      type: Boolean,
      default: true
    },
    languageId: {
      type: String,
      default: () => ""
    }
  },
  components: {
    ContentItem,
    ContentEditor
  },
  data() {
    return {
      showContentEditor: false,
      editedContent: {}
    };
  },
  computed: {
    featuredImg() {
      let img =
        "https://www.pixelstalk.net/wp-content/uploads/2016/06/Hawaii-Wallpapers-HD-Free-Download.jpg";
      let contentImage = this.item.allContents.find(item => item.imgURL != "");
      return contentImage ? contentImage.imgURL : img;
    }
  },
  methods: {
    filter(list) {
      return this.languageId != ""
        ? list.filter(c => c.languageId == this.languageId)
        : list;
    },
    onEditContent($payload) {
      //console.log('payload:',$payload);
      this.editedContent = $payload;
      this.showContentEditor = true;
    },
    onEditCancel() {
      this.showContentEditor = false;
      this.editedContent = {};
    },
    onContentSaved($payload) {
      //just reload for now
      this.$emit("reload");
      // if($payload.owner == 'SUPPLIER'){
      //     let editedItem = this.item.contents.edges.find(item => item.node.id == $payload.id);
      //     if(editedItem != undefined) {
      //         editedItem.node.description = $payload.description;
      //         editedItem.node.name = $payload.name;
      //     }
      //     console.log('edited supplier content', editedItem)
      // }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/plugins/supplier-contents/SupplierContentsItem.vue